import React from 'react';
import { Icon } from './Icon.jsx';

/** Tag — filter/selection chip. Toggles selected state; optionally removable. */
export function Tag({ children, selected = false, onClick, onRemove, icon, style, ...rest }) {
  const [hover, setHover] = React.useState(false);
  return (
    <span
      onClick={onClick}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{
        display: 'inline-flex', alignItems: 'center', gap: 6,
        background: selected ? 'var(--secondary)' : (hover ? 'var(--surface-hover)' : 'var(--surface-card)'),
        color: selected ? 'var(--on-secondary)' : 'var(--text-body)',
        border: `2px solid ${selected ? 'var(--secondary)' : 'var(--border-strong)'}`,
        fontFamily: 'var(--font-sans)', fontWeight: 'var(--fw-semibold)', fontSize: 'var(--text-sm)',
        padding: '6px 12px', borderRadius: 'var(--radius-pill)', lineHeight: 1.2,
        cursor: onClick ? 'pointer' : 'default',
        transition: 'background var(--dur-fast) var(--ease-out), border-color var(--dur-fast) var(--ease-out)',
        ...style,
      }}
      {...rest}
    >
      {icon && <Icon name={icon} size={14} />}
      {children}
      {onRemove && (
        <button type="button" aria-label="Remove"
          onClick={(e) => { e.stopPropagation(); onRemove(); }}
          style={{ display: 'inline-flex', border: 'none', background: 'transparent', padding: 0, marginLeft: 2, cursor: 'pointer', color: 'inherit', opacity: 0.7 }}>
          <Icon name="x" size={14} strokeWidth={2.5} />
        </button>
      )}
    </span>
  );
}
